export default __webpack_public_path__ + "static/media/quill.ff23e3b0.png";